import React from 'react';
import { Title, Text, Box, Button, Flex, Accordion } from '@mantine/core';
import { useTypedSelector } from '@/store/hooks';
import { formatPrice, generateConfigurationCode } from '@/utils/utilities';
import { ProductLength } from './steps/ProductLength';
import { SiphonsQuantity } from './steps/SiphonsQuantity';
import { SiphonsPlacement } from './steps/SiphonsPlacement';
import { Products } from '../partials/products/Products';
import { Attribute } from '../partials/attribute/Attribute';
import { useContent } from '@/providers/ContentProvider';
import ProductApi from '@/api/ProductApi';
import styles from './Aside.module.scss';

const baseSlug = 'creator.';

const CODE_SEGMENT_COLORS = ['blue', 'dark', 'grape', 'yellow'];

export const Aside: React.FC = () => {
	const { getContent } = useContent();

	const creatorState = useTypedSelector((state) => state.creator);
	const { preparedAttributes, length, matchedVariation, realizationTime } =
		creatorState;
	const configurationCode = generateConfigurationCode(creatorState);

	return (
		<Box
			component="aside"
			className={styles.container}
			id="creator-aside"
			pb="md"
			px={{ base: 'md', md: 'lg' }}
		>
			<Title order={2} pt="md" className={styles.title} mb="xs">
				Cena:{' '}
				{formatPrice(
					matchedVariation
						? (matchedVariation.pricePerMeter * length) / 100_000
						: 0,
					{
						currencyDisplay: 'symbol',
					}
				)}{' '}
				(brutto){' '}
			</Title>
			{!!realizationTime && (
				<Text>
					Czas realizacji:{' '}
					<Text span fw="bold">
						{realizationTime}
					</Text>
				</Text>
			)}
			{!!configurationCode.length && (
				<Text>
					Kod konfiguracji:{' '}
					{configurationCode.map(
						(segment, idx) =>
							!!segment && (
								<Text key={idx} span fw="bold" c={CODE_SEGMENT_COLORS[idx]}>
									{segment}
								</Text>
							)
					)}
				</Text>
			)}
			<Accordion defaultValue={ProductApi.queryKey} mt="lg">
				<Products />
				{preparedAttributes.map((preparedAttribute) => (
					<Attribute
						key={preparedAttribute.id}
						preparedAttribute={preparedAttribute}
					/>
				))}
				<ProductLength />
				<SiphonsQuantity />
				<SiphonsPlacement />
			</Accordion>

			<Box mt="auto">
				<Flex justify="space-between">
					<Button
						size="lg"
						type="submit"
						fullWidth
						disabled={!matchedVariation}
					>
						{getContent(`${baseSlug}cartButton`)}
					</Button>
				</Flex>
			</Box>
		</Box>
	);
};
